import { Box, CircularProgress, Divider, Typography } from "@mui/material";
import React, { useEffect } from "react";
import AppBarResourceList from "../components/AppBar/ResourceList";
import ResourceListsTable from "../components/ResourceLists.jsx/Table";
import { getAllData } from "../libs/firebase/firestore/getAllData";
import { useNavigateToTop } from "../libs/useNavigateToTop";

function ScreenCreateResourceLists({}) {
  const navigate = useNavigateToTop();
  // state for the reource list
  const [resourceLists, setResourceLists] = React.useState([]);

  // loading state
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    // get the resource lists from firebase
    getAllData("/resourceLists").then((data) => {
      setResourceLists(data);
      setLoading(false);
    });

    // get the materials from firebase
  }, []);

  return (
    <Box>
      <AppBarResourceList />

      <Box
        style={{
          padding: "2rem",
          margin: "auto 0",
        }}
      >
        {/* Title and subtitle */}
        <Typography variant="h5">Resource Lists</Typography>
        <Typography variant="subtitle1">
          All the resource lists created
        </Typography>

        <Divider
          sx={{
            my: 2,
          }}
        />
        {/* loader */}
        {loading && (
          <Box
            style={{
              textAlign: "center",
              margin: "2rem 0rem",
            }}
          >
            <CircularProgress />
          </Box>
        )}
        <ResourceListsTable
          onClick={(resourceList) => {
            navigate(`/resource-list/${resourceList.storageDocumentId}`);
          }}
          // onDelete={handleOnDelete}
          data={resourceLists}
        />
      </Box>
    </Box>
  );
}

export default ScreenCreateResourceLists;
